import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState } from 'react';
import useWindowSize from '../../hooks/useWindowSize.js';
import ContentWithSelect from './ContentWithSelect.js';
import ContentWithTabs from './ContentWithTabs.js';

var _excluded = ["data", "isVertical"];
var TabbedContent = function TabbedContent(_ref) {
  var data = _ref.data,
    _ref$isVertical = _ref.isVertical,
    isVertical = _ref$isVertical === void 0 ? false : _ref$isVertical,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentData = _useState2[0],
    setCurrentData = _useState2[1];
  var windowSize = useWindowSize();
  return windowSize.width > 700 ? /*#__PURE__*/React__default.createElement(ContentWithTabs, _extends({
    className: "leshen-tabs content-with-tabs",
    data: data,
    isVertical: isVertical
  }, props)) : /*#__PURE__*/React__default.createElement(ContentWithSelect, {
    className: "leshen-tabs content-with-select",
    currentData: currentData,
    setCurrentData: setCurrentData,
    data: data
  });
};
var TabbedContent$1 = TabbedContent;

export { TabbedContent$1 as default };
//# sourceMappingURL=index.js.map
